import {
	HttpErrorResponse,
	HttpEvent,
	HttpHandler,
	HttpInterceptor,
	HttpRequest
} from '@angular/common/http';
import { ErrorObservable } from 'rxjs/observable/ErrorObservable';
import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';

@Injectable()
export class BlobErrorInterceptor implements HttpInterceptor {
	intercept(
		req: HttpRequest<any>,
		next: HttpHandler
	): Observable<HttpEvent<any>> {
		return next.handle(req).catch(err => this.handleBlobErrors(err));
	}

	private handleBlobErrors(
		err: HttpErrorResponse
	): Promise<HttpErrorResponse> | ErrorObservable {
		if (
			err instanceof HttpErrorResponse &&
			err.error instanceof Blob &&
			err.error.type === 'application/json'
		) {
			// https://github.com/angular/angular/issues/19888
			// When request of type Blob, the error is also in Blob instead of object of the json data
			return new Promise<any>((resolve, reject): void => {
				const reader = new FileReader();
				reader.onload = (e: Event): void => {
					try {
						const errmsg = JSON.parse((<any>e.target).result);
						reject(
							new HttpErrorResponse({
								error: errmsg,
								headers: err.headers,
								status: err.status,
								statusText: err.statusText,
								url: err.url
							})
						);
					} catch (e) {
						reject(err);
					}
				};
				reader.onerror = (): void => {
					reject(err);
				};
				reader.readAsText(err.error);
			});
		}
		return Observable.throw(err);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./shared/interceptors/blobError.interceptor.ts